import { init, routingInstrumentation } from "@sentry/angular";
import * as Sentry from "@sentry/browser";
import { sentryReleaseVersion } from "sentry-release-version";
import { environment } from "src/environments/environment";
import { UserInfo, UserTypes } from "../../shared/types/user-info";
import { LocalStorageKeys } from "../storage/local-storage";
import { getViewAsValue } from "../storage/local-storage.util";

export function sentryInstance(): void {
  init({
    dsn: environment.sentryDsn,

    /* The sample rate for replays that begin recording immediately and last the entirety of the user's session. 1.0 will collect all replays, 0 will collect no replays */
    replaysSessionSampleRate: 0,

    /* The sample rate for replays that are recorded when an error happens. This type of replay will record up to a minute of events prior to the error and continue recording until the session ends. 1.0 capturing all sessions with an error, and 0 capturing none. */
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new Sentry.BrowserTracing({
        tracingOrigins: environment.sentryTraceOrigins,
        routingInstrumentation: routingInstrumentation,
      }),
      new Sentry.Replay({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    denyUrls: ["localhost"],
    release: sentryReleaseVersion,
    environment: environment.env,
    attachStacktrace: true,
    tracesSampleRate: 1.0,
  });

  const userSession: UserInfo = JSON.parse(localStorage.getItem(LocalStorageKeys.currentUser));

  const viewAsCompany = getViewAsValue("company");
  const viewAsPartner = getViewAsValue("partner");

  if (userSession) {
    Sentry.setUser({
      id: userSession.id,
      email: userSession.email,
      role: userSession.role,
      ...(userSession.type === UserTypes.Partner && { partner: userSession.partner }),
      ...(userSession.type === UserTypes.Company && { company: userSession.company }),
      ...(viewAsPartner && !viewAsCompany && { viewAsPartner }),
      ...(!viewAsPartner && viewAsCompany && { viewAsCompany }),
    });
  }
}
